import { MapperBase } from '../../utilities/mapper-base';
import { NearDupTextGroupingResource } from '../resource/near-dup-text-grouping.resource';
import { NearDupTextGrouping } from '../ui/near-dup-text-grouping.model';

export class NearDupTextGroupingResourceToNearDupTextGroupingMapper extends MapperBase<NearDupTextGroupingResource, NearDupTextGrouping> {
	map(source: NearDupTextGroupingResource): NearDupTextGrouping {
		const dest = new NearDupTextGrouping();
		dest.textGroupId = source.textGroupId;
		dest.docCount = source.docCount;
		dest.groupTitle = `Group ${source.textGroupId}`;
		return dest;
	}

}
